<template>
  <div class="yxds-wrap">
    <div class="productBar">
      <div class="auto">
        <h2>产品：大智慧优选大师财富版<span>非投资咨询类软件产品</span></h2>
      </div>
    </div>
    <div class="title1">
      <img src="../../assets/images/activity/yxds2021/title1.png" alt="">
    </div>
    <img src="../../assets/images/activity/yxds2021/img1.png" alt="">
    <div class="title2">
      <img src="../../assets/images/activity/yxds2021/title2.png" alt="">
    </div>
    <img src="../../assets/images/activity/yxds2021/img2.png" alt="">
    <div class="mod hot-mod">
      <div class="title">热点风向</div>
      <div class="con">
        <dl>
          <dt>热点板块轮动</dt>
          <dd class="text">采用独创的算法，智能研判板块及成份股的领涨领跌情况，辅助用户把握最新的热点风向。</dd>
          <dd>
            <img src="../../assets/images/activity/yxds2021/img3-1.png" alt="">
          </dd>
        </dl>
        <dl>
          <dt>个股资金轮动</dt>
          <dd class="text">智能分析活跃大资金在个股间的轮动轨迹。</dd>
          <dd>
            <img src="../../assets/images/activity/yxds2021/img3-2.png" alt="">
          </dd>
        </dl>
        <dl>
          <dt>ACE资金排行</dt>
          <dd class="text">ACE净额、资金先锋、涨跌动能多维度实时监控“热钱”的流向。</dd>
          <dd>
            <img src="../../assets/images/activity/yxds2021/img3-3.png" alt="">
          </dd>
        </dl>
      </div>
    </div>
    <div class="mod strategy-mod">
      <div class="title">优选策略</div>
      <div class="con">
        <dl>
          <dt>优选500</dt>
          <dd class="text">基于海量交易数据优选500支“人气股”，它们或为机构抱团股的代表、或为游资私募的“新欢”。辅以精准的智能技术诊断放进8个股池，方便用户监控市场风向的变化。</dd>
          <dd><img src="../../assets/images/activity/yxds2021/img4-1.png" alt=""></dd>
        </dl>
        <dl>
          <dt>赢在开盘</dt>
          <dd class="text">精准定位集合竞价异动的高活跃板块与个股。</dd>
          <dd><img src="../../assets/images/activity/yxds2021/img4-2.png" alt=""></dd>
        </dl>
        <dl>
          <dt>盘中黑马</dt>
          <dd class="text">基于云端的股票池功能，市值、波幅、市盈三种维度满足不同用户的需求。用户可自主定制策略，预警结果及时推送。</dd>
          <dd><img src="../../assets/images/activity/yxds2021/img4-3.png" alt=""></dd>
        </dl>
        <dl>
          <dt>收盘点睛</dt>
          <dd class="text">回顾历史，发现更多机会。</dd>
          <dd><img src="../../assets/images/activity/yxds2021/img4-4.png" alt=""></dd>
        </dl>
      </div>
    </div>
    <div class="mod inter-mod">
      <div class="title">优选内参</div>
      <div class="con">
        <dl>
          <dt><i>/</i>一致预期<i>/</i>热点追踪<i>/</i>短期策略<i>/</i></dt>
          <dd class="text">专业团队以机构视角设计，采用AI技术从海量财经资讯、研报中为高净值用户优选精华内容，辅助投资者紧跟市场风口。</dd>
          <dd><img src="../../assets/images/activity/yxds2021/img5-1.png" alt=""></dd>
        </dl>
      </div>
    </div>
    <div class="btn-wrap" @click="goUrl(197)"><span class="btn-buy">立即抢购</span></div>
    <div class="fixed-code">
      <img src="../../assets/images/activity/yxds2021/code.png" alt="">
      <p>扫一扫立即下载<br/>大智慧APP</p>
    </div>
    <float-bar :id="id" :month="month"/>
  </div>
</template>

<script>
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  components: {
    FloatBar,
  },
  data() {
    return {
      id: this.$parent.id,
      month : 12
    };
  },
  methods: {
    goUrl(key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({
          name: "ClientProduct",
          query: { token: this.token, pid: key },
        });
      } else {
        routerDate = this.$router.resolve({
          name: "OrderConfirm",
          params: { productId: key, month: 12 },
        });
      }
      let href = routerDate.href +'?s=official';
      window.open(href, "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
.yxds-wrap{
  padding-bottom: 80px;
  background: url(../../assets/images/activity/yxds2021/bg.jpg) no-repeat center 84px #1d1a28;
  .productBar{
    margin-bottom: 1050px;
    background: #fff;
  }
  .fixed-code{
    position: fixed;
    top: 184px;
    right: 50%;
    margin-right: -600px;
    width: 140px;
    padding: 10px 0;
    background: #c47c3f;
    p{
      font-size: 18px;
      color: #fff;
      line-height: 24px;
      text-align: center;
      margin-top: 5px;
    }
  }
  img{
    margin: 0 auto;
    display: block;
  }
  .title1{
    margin: 0 auto 50px;
    img{
      display: block;
      margin: 0 auto;
    }
  }
  .title2{
    margin: 50px auto 50px;
  }
  .mod{
    background: url(../../assets/images/activity/yxds2021/bg2.png) no-repeat center top #312e3b;
    width: 1200px;
    margin: 50px auto;
    border-radius: 10px;
    .title{
      font-size: 40px;
      color: #663B16;
      padding-left: 45px;
      height: 55px;
      line-height: 55px;
    }
    .con{
      overflow: hidden;
      padding: 40px 60px 30px;
    }
    dl{
      float: left;
      dt{
        font-size: 30px;
        color: #FFD0A8;
        &:before{
          content: '';
          display: inline-block;
          background: #FFD0A8;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          vertical-align: middle;
          margin: 0 15px 0 -25px;
        }
      }
      .text{
        opacity: 0.6;
        font-size: 20px;
        color: #FFD0A8;
      }
    }
  }
  .hot-mod{
    dl{
      &:nth-child(1) {
        width: 290px;
      }
      &:nth-child(2) {
        width: 293px;
        margin: 0 100px;
      }
      &:nth-child(3) {
        width: 285px;
      }
      .text{
        height: 85px;
        margin: 10px 0 30px;
      }
    }
  }
  .strategy-mod{
    img{
      margin: 0;
    }
    dl{
      dt{
        margin-bottom: 20px;
      }
      &:nth-child(odd) {
        width: 470px;
        margin-right: 120px;
      }
      &:nth-child(even) {
        width: 488px;
      }
      &:nth-child(1) {
        margin-bottom: 42px;
        .text{
          margin-bottom: 20px;
        }
      }
      &:nth-child(2) {
        .text{
          margin-bottom: 40px;
        }
      }
      &:nth-child(3) {
        .text{
          margin-bottom: 20px;
        }
      }
      &:nth-child(4) {
        .text{
          margin-bottom: 77px;
        }
      }
    }
  }
  .inter-mod{
    dl{
      float: none;
      dt{
        &:before{
          display: none;
        }
        i{
          margin: 0 20px;
          &:nth-child(1) {
            margin-left: 0;
          }
        }
      }
      .text{
        margin:10px 0 38px;
      }
    }
  }
}
.btn-wrap{width: 300px;position: fixed;left:50%;bottom:135px;-webkit-transform: translate(-50%,0);-ms-transform: translate(-50%,0);transform: translate(-50%,0);z-index: 100;cursor: pointer;}
.btn-buy{display: block;width: 100%;border:2px solid #fff;line-height: 74px;height: 74px;font-size: 30px;color: #784516;font-weight: bold;text-align: center;background-image: linear-gradient(180deg,#febb85 0%,#fff4cc 100%);background-image: -webkit-linear-gradient(top,#febb85 0%,#fff4cc 100%);border-radius:200px;position: relative;z-index: 1;box-sizing: border-box;}
.btn-buy:after,.btn-buy:before,.btn-wrap:after{content:'';position: absolute;top:-2px;left:50%;height: 100%;border:2px solid #fff;border-radius:200px;-webkit-transform: translate(-50%,0);-ms-transform: translate(-50%,0);transform: translate(-50%,0);}
.btn-buy:before{width: 120%;opacity: 0.6;}
.btn-buy:after{width: 140%;opacity: 0.3;}
.btn-wrap:after{width: 160%;opacity: 0.14;}
</style>


// WEBPACK FOOTER //
// src/components/product/Product197.vue